import React from 'react';
import * as PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Form from '../../form/components/Form';
import Select from '../../form/components/Select';
import SubmitButton from '../../form/components/SubmitButton';
import { IdPropType, RefPropType } from '../../../proptypes/basic';
import { useResourceSubmit } from '../../form/hooks';
import { CUSTOMER_RESOURCE } from '../../api/resources';
import { notInterestedSchema } from '../schema';

const useStyles = makeStyles((theme) => ({
    spaceLarge: {
        minHeight: 60,
        marginBottom: theme.spacing(4),
    },
}));

const NotInerestedForm = ({ customerId, submitRef, onDone }) => {
    const classes = useStyles();

    const initialValues = {
        icNotInterestedReason: '',
        icNotInterestedDate: new Date(),
    };

    const handleSubmit = useResourceSubmit(
        customerId,
        CUSTOMER_RESOURCE,
        { currentType: { name: 'prospective_former' } },
        { onDone }
    );

    return (
        <Form
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validationSchema={notInterestedSchema}
        >
            <Grid container spacing={2}>
                <Grid item xs={12} className={classes.spaceLarge}>
                    <Select label="Grund" name="icNotInterestedReason" fullWidth />
                </Grid>
            </Grid>
            <SubmitButton container={submitRef} />
        </Form>
    );
};

NotInerestedForm.propTypes = {
    customerId: IdPropType.isRequired,
    onDone: PropTypes.func.isRequired,
    submitRef: RefPropType,
};

NotInerestedForm.defaultProps = {
    submitRef: null,
};

export default NotInerestedForm;
